import { AdvancedImage } from '@cloudinary/react'
import type { Product } from '@prisma/client'
import cld from '~/services/cloudinary/cloudinaryInstance.tsx'
import React from 'react'

function generateProductImg(imgSrc: string) {
	return cld.image(imgSrc).quality('auto').format('auto')
}

export default function ProductCard({
	product,
}: {
	product: Product
}): React.JSX.Element {
	return (
		<div className="rounded-lg border-2 border-gray-100 shadow shadow-gray-100">
			<a
				key={product.id}
				href={`/store/products/${product.id}`}
				className="group"
			>
				<div className="aspect-h-1 aspect-w-1 sm:aspect-h-3 sm:aspect-w-2 w-full overflow-hidden rounded-lg">
					<AdvancedImage
						cldImg={generateProductImg(product.imgSrc)}
						alt={product.imgAlt}
						className="h-full w-full object-contain object-center group-hover:opacity-75"
					/>
				</div>
				<div className="mt-2 flex items-center justify-center p-2 text-base font-medium text-gray-900">
					<h3>{product.name}</h3>
					{/*<p>${product.variations[0].price}</p>*/}
				</div>
				<p className="flex items-center justify-center p-2 text-sm italic text-gray-500">
					{product.description}
				</p>
			</a>
		</div>
	)
}
